// Visible copy lives in i18n (src/i18n/locales/*). This file holds only the
// images and asset lists for the About page sections (all sections retained).

export const aboutData = {
  image1: "/images/about-img-1.jpg",
  image2: "/images/about-img-2.jpg",
  selling: {
    image1: "/images/best-selling-img-1.jpg",
    image2: "/images/best-selling-img-2.jpg",
  },
  clients: {
    list: [
      { url: "/images/partners/partner-logo-01-goldenview.png", alt: "Goldenview Interior Ltd" },
      { url: "/images/partners/partner-logo-02-cohaus.png", alt: "CoHaus Projects" },
      { url: "/images/partners/partner-logo-03-n2.png", alt: "N2 Engineering Consultants" },
      { url: "/images/partners/partner-logo-04-surex.png", alt: "Surex Consulting" },
      { url: "/images/partners/partner-logo-05-stronghold.png", alt: "Stronghold Engineers" },
      { url: "/images/partners/partner-logo-06-aform.png", alt: "AForm" },
      { url: "/images/partners/partner-logo-07-mcnally.png", alt: "McNally Management" },
    ],
  },
};
